import { useGetAssignmentConfigQuery } from '@src/reducers/assignmentManager';
import AutoAssignSelector from './AutoAssignSelector';
import ContactAssignSelector from './ContactAssignSelector';

export type OwnerAssignSelectProps = {
  contactId: string;
};

const OwnerAssignSelector: React.FC<OwnerAssignSelectProps> = ({
  contactId,
}) => {
  const config = useGetAssignmentConfigQuery();
  const assignmentPermission = config.data?.assignmentPermission;

  return (
    <>
      {assignmentPermission === 'ASSIGN_ANY_AGENT_OR_DEPARTMENT' ? (
        <ContactAssignSelector contactId={contactId} />
      ) : (
        assignmentPermission === 'SELF_ASSIGNMENT_ONLY' && (
          <AutoAssignSelector contactId={contactId} />
        )
      )}
    </>
  );
};

export default OwnerAssignSelector;
